// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 获取当前用户有效银行卡列表 GET /api/v1/app-user/bankcard */
export async function AppUserBankcardControllerGetActiveBankcardListV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputUserBankcardDtoArray>(
    "/api/v1/app-user/bankcard",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 绑定银行卡 POST /api/v1/app-user/bankcard/bind */
export async function AppUserBankcardControllerBindBankcardV1(
  body: MyApi.BindBankcardDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputGatewayPreBindCardResult>(
    "/api/v1/app-user/bankcard/bind",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 确认绑卡 POST /api/v1/app-user/bankcard/confirm-bind */
export async function AppUserBankcardControllerConfirmBindBankcardV1(
  body: MyApi.ConfirmBindBankcardDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputUserBankcardDto>(
    "/api/v1/app-user/bankcard/confirm-bind",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** 获取当前用户有效银行卡数量 GET /api/v1/app-user/bankcard/count */
export async function AppUserBankcardControllerGetActiveBankcardCountV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseNumber>("/api/v1/app-user/bankcard/count", {
    method: "GET",
    ...(options || {}),
  });
}

/** 查询绑卡结果 GET /api/v1/app-user/bankcard/query-bind */
export async function AppUserBankcardControllerQueryBindBankcardV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppUserBankcardControllerQueryBindBankcardV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputUserBankcardDto>(
    "/api/v1/app-user/bankcard/query-bind",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}
